import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import CardDetailsProject from "../../../components/card-details-project/CardDetailsProject";
import headerBg from "../../../assets/background/headebg.png";
import headerMobileBg from "../../../assets/images/heroMobile3.jpg";
import DonationCard from "../../../biblio/Cards/DonationCard";
import { getDonationTypes } from "../../../apis/actions/donation.actions";
import { AppDispatch, RootState } from "../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "../../communs/NavBar";
import FooterSection from "../../../components/sections/FooterSection";
import Loader from "../../../biblio/Loader/Loader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getDetailsKorba } from "../../../apis/actions/korba.actions";
import OtherKorbasCard from "./OtherKorbaCard";
import HeroSectionDetailsProject from "../layout-details-project/HeroSectionDetailsProject";
import { getModel } from "../../../components/utils/utils";
import Seo from "../../../components/seo/Seo";

const LayoutDetailsKorba = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const donationAmount = location.state?.donationAmount;
  const counter = location.state?.counter;
  const selectedShare = location.state?.selectedShare;
  const selectedDonation = location.state?.selectedDonation;
  const dispatch = useDispatch<AppDispatch>();
  const { access_token, key } = useParams();
  const [loading, setLoading] = useState(true);

  const donationTypes = useSelector(
    (state: RootState) => state?.donation?.donationTypes
  );
  const detailKorba = useSelector(
    (state: RootState) => state?.korbas?.detailsKorba
  );
  useEffect(() => {
    dispatch(getDetailsKorba({ access_token, model: getModel(key) }));
    setLoading(true);
    dispatch(getDonationTypes());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, access_token]);

  useEffect(() => {
    if (detailKorba && Object.keys(detailKorba).length === 0) {
      navigate("/");
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailKorba]);

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  const handleClick = (body: any) => {
    console.log(body);
  };
  return (
    <div className="takaful--layout-details">
      <Seo
        title={detailKorba?.summary}
        description={detailKorba?.brief}
        image={
          detailKorba?.detail_image_ids?.[0] ?? detailKorba?.title_image_ids?.[0]
        }
      />
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title="الحالات"
        subTitle="تفاصيل الحالة"
        urlImage={headerBg}
        mobileImage={headerMobileBg}
        type={"تفريج كرب"}
      />
      <Row dir="rtl" gutter={16} justify={"space-between"}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col
          xxl={14}
          xl={14}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          <CardDetailsProject project={detailKorba} type="تفريج كرب" />
        </Col>
        <Col
          xxl={7}
          xl={7}
          lg={12}
          md={12}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          <DonationCard
            project={detailKorba}
            handleClick={handleClick}
            donationAmounts={[]}
            donationTypes={donationTypes}
            variant="payment"
            className="takaful--donation-details"
            donationAmount={donationAmount}
            counter={counter}
            selectedShare={selectedShare}
            selectedDonation={selectedDonation}
            remainingAmount={detailKorba?.remaining_amount}
            type="تفريج كرب"
          />
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
      </Row>
      <OtherKorbasCard />
      <FooterSection />
    </div>
  );
};

export default LayoutDetailsKorba;
